<div class="drawer lg:drawer-open bg-base-100 h-full w-full">
	<input
		id="admin-drawer"
		type="checkbox"
		class="drawer-toggle"
		#adminDrawerToggle
	/>
	<div class="drawer-content flex h-full min-w-0 flex-col">
		<header class="navbar bg-base-200 border-base-300 border-b">
			<div class="flex-none lg:hidden">
				<label for="admin-drawer" aria-label="open sidebar" class="btn btn-square btn-ghost">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						class="h-6 w-6 stroke-current"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M4 6h16M4 12h16M4 18h16"
						/>
					</svg>
				</label>
			</div>
			<div class="flex-1">
				<a
					class="btn btn-ghost text-xl"
					routerLink="/admin"
					[translate]
					>Admin dashboard</a
				>
			</div>
			<div class="flex-none">
				<a
					class="btn btn-ghost"
					routerLink="/host/dashboard"
					[translate]
					>Back to Dashboard</a
				>
			</div>
		</header>
		<div class="min-h-0 grow overflow-y-auto p-4">
			<router-outlet></router-outlet>
		</div>
	</div>
	<div class="drawer-side z-20">
		<label for="admin-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
		<aside class="bg-base-200 min-h-full w-56">
			<ul class="menu w-full">
				@for (navigationItem of navigationItems; track navigationItem.path) {
					<li>
						<a
							[routerLink]="navigationItem.path"
							routerLinkActive="active"
							(click)="adminDrawerToggle.checked = false"
						>
							<span>{{ navigationItem.label() }}</span>
						</a>
					</li>
				}
			</ul>
		</aside>
	</div>
</div>
